import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScreensComponent } from './screens.component';
import { AppNgAppkitModule } from '../app-ng-appkit.module';
import { ReverseArrayPipe } from '../shared/pipes/reverse-array.pipe';
import { GtwDirectivesModule } from '../shared/_directives/gtw-directives.module';

@NgModule({
  declarations: [ScreensComponent, ReverseArrayPipe],
  imports: [CommonModule, AppNgAppkitModule, GtwDirectivesModule],
  exports: [ScreensComponent],
})
export class ScreensModule {}
